<template>
    <form-view class="user-account-password-view" @submitsuccess="redirect('/user/account')">
        <template slot="field">
            <veui-field label="旧密码：" name="oldPassword" field="oldPassword" rules="required">
                <veui-input type="password" v-model="store.formData.oldPassword"/>
            </veui-field>
            <veui-field label="新密码：" name="newPassword" field="newPassword" :rules="validator('required|password')">
                <veui-input type="password" v-model="store.formData.newPassword"/>
            </veui-field>
            <veui-field label="再次输入新密码："
                name="newPasswordAgain"
                field="newPasswordAgain"
                :rules="validator('required|sameWith:newPassword=两次输入的密码不一致')">
                <veui-input type="password" v-model="store.formData.newPasswordAgain"/>
            </veui-field>
        </template>

        <template slot="operation">
            <veui-button ui="primary" type="submit">提交</veui-button>
            <veui-button ui="aux" @click="back">取消</veui-button>
        </template>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import PasswordFormModel from './PasswordFormModel';
import createView from '@baidu/ve-ria/views/createView';
import {Field, Button, Input, Span} from 'veui';

export default createView(FormView, PasswordFormModel, {
    name: 'PasswordFormView',
    components: {
        'veui-field': Field,
        'veui-input': Input,
        'veui-span': Span,
        'veui-button': Button
    }
});
</script>

<style lang="less">
.user-account-password-view {
    .veui-form-label {
        width: 130px;
    }
}
</style>
